import { initialSort, type ParticipantLikeObject } from 'features/Room/hooks/useInitialSort';

export type TestParticipant = ParticipantLikeObject;

const TEST_PARTICIPANT_COUNT = 25;

const UserData = () => {
    let id = 0;
    let joinedAt = new Date().getTime() - 1000 * 60 * 60 * 10;

    return {
        get userId() {
            return ++id;
        },

        get joinedAt() {
            joinedAt += 1000 * 60 * 5;
            return joinedAt;
        },

        get lastSpokeAt() {
            return undefined;
        },
    };
};

const userData = UserData();

function createMockParticipant(overrides = {} as any) {
    const joinedAt = new Date(userData.joinedAt);
    const lastSpokeAt = userData.lastSpokeAt ? new Date(userData.lastSpokeAt) : undefined;

    return {
        identity: overrides.identity ? overrides.identity : `user-${userData.userId}`,
        joinedAt,
        isScreenShareEnabled: Math.random() > 0.9 ? true : false,
        isSpeaking: false,
        isLocal: false,
        lastSpokeAt,
        ...overrides,
    };
}

const localSpeaker = createMockParticipant({
    isLocal: true,
    isSpeaking: true,
    identity: 'current-user',
});

const testParticipants: TestParticipant[] = [
    localSpeaker,
    ...new Array(TEST_PARTICIPANT_COUNT).fill(0).map(() => createMockParticipant()),
];

export const participants = initialSort<TestParticipant>(testParticipants);
